// components/gallery/PhotoGrid/styles.js
import styled from "styled-components";

export const GridContainer = styled.div`
	columns: 3;
	column-gap: ${(props) => props.theme.spacing.md};
	padding: ${(props) => props.theme.spacing.xl};

	@media (max-width: ${(props) => props.theme.breakpoints.lg}) {
		columns: 2;
	}

	@media (max-width: ${(props) => props.theme.breakpoints.sm}) {
		columns: 1;
	}
`;

export const PhotoCard = styled.div`
	break-inside: avoid;
	margin-bottom: ${(props) => props.theme.spacing.md};
	position: relative;
	cursor: pointer;
	border-radius: ${(props) => props.theme.borderRadius.md};
	overflow: hidden;

	&:hover img {
		transform: scale(1.05);
	}
`;

export const Photo = styled.img`
	width: 100%;
	height: auto;
	display: block;
	transition: transform ${(props) => props.theme.transitions.normal};
`;

export const PhotoInfo = styled.div`
	position: absolute;
	bottom: 0;
	left: 0;
	right: 0;
	padding: ${(props) => props.theme.spacing.md};
	background: linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent);
	opacity: 0;
	transition: opacity ${(props) => props.theme.transitions.normal};

	${PhotoCard}:hover & {
		opacity: 1;
	}
`;

export const PhotoTitle = styled.h4`
	color: white;
	font-size: ${(props) => props.theme.typography.sizes.md};
	margin-bottom: ${(props) => props.theme.spacing.xs};
`;

export const PhotoCaption = styled.p`
	color: rgba(255, 255, 255, 0.9);
	font-size: ${(props) => props.theme.typography.sizes.sm};
`;
